import { DuringContractCompanyListPage } from "@/features/company/pages/DuringContractCompanyList";
import React from "react";

const DuringContractCompanyList = () => {
  return <DuringContractCompanyListPage />;
};

export default DuringContractCompanyList;
